import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { trackPageView } from '../utils/trackingUtils';

export default function PaymentPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView('ORDER', 'payment-page');
  }, []);

  return (
    <>
      <Helmet>
        <title>Secure Your Spot - EmploSkills</title>
        <meta 
          name="description" 
          content="Complete your registration for the Virtual Business Challenge Class. Secure your spot today!"
        />
      </Helmet>
      
      <div className="py-6 md:py-10 px-0 sm:px-2 bg-white">
        <div className="text-center mb-6 max-w-4xl mx-auto px-2">
          <h1 className="text-4xl font-bold mb-3">Complete Your Registration</h1>
          <p className="text-lg text-gray-600">
            You're just one step away from securing your spot in the Virtual Business Challenge Class
          </p>
        </div>
        
        {/* HubSpot Payment Container - Full Width */}
        <div className="w-full bg-white shadow-lg rounded-xl overflow-hidden">
          {/* HubSpot Payment Embed */}
          <div>
            <iframe 
              src="https://app-eu1.hubspot.com/payments/wRKsKVyHnynm7j"
              className="w-full min-h-[600px]"
              style={{ height: '100vh', maxHeight: '1200px' }}
              title="Payment Form"
              allow="payment; fullscreen"
              frameBorder="0"
              scrolling="yes"
            ></iframe>
          </div>
        </div>
        
        {/* Info Box */}
        <div className="max-w-4xl mx-auto mt-8 px-4">
          <div className="p-4 bg-blue-50 rounded-lg">
            <h3 className="font-semibold text-lg mb-2">What happens after payment?</h3>
            <p className="text-gray-700">
              After completing your payment, you'll receive an email confirmation with all the 
              details you need to join the class, including login information and preparation steps.
            </p>
          </div>
        </div>
        
        {/* FAQ Section */}
        <div className="mt-10 max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
          
          <div className="space-y-5">
            <div className="border-b pb-4">
              <h3 className="font-semibold text-lg mb-2">What's included in my registration?</h3>
              <p className="text-gray-700">
                Your registration includes full access to the Virtual Business Challenge Class, all simulation materials, 
                and a certificate of completion.
              </p>
            </div>
            
            <div className="border-b pb-4">
              <h3 className="font-semibold text-lg mb-2">Is there a refund policy?</h3>
              <p className="text-gray-700">
                Yes, we offer a full refund if canceled at least 7 days before the class starts. 
                Please contact us at contact@empleoskills.com for more information.
              </p>
            </div>
            
            <div className="border-b pb-4">
              <h3 className="font-semibold text-lg mb-2">What technology requirements are needed?</h3>
              <p className="text-gray-700">
                Students will need a computer with internet access, a web browser, and the ability 
                to join a video call. No special software installation is required.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 